import { render, staticRenderFns } from "./businessdetail.vue?vue&type=template&id=d96fb2aa&scoped=true"
import script from "./businessdetail.vue?vue&type=script&lang=js"
export * from "./businessdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96fb2aa",
  null
  
)

export default component.exports